import { Dispatch, GetState } from "common/types/redux";

import {
  secureAuthenticationProcessingFinished,
  secureAuthenticationProcessingStarted,
  setPaymentError,
  subscriptionIsActive,
  subscriptionPaymentFailed
} from "seneca-common/features/subscriptions/state";
import {
  confirmSubscriptionStatus,
  fetchPaymentIntentClientSecret
} from "seneca-common/features/subscriptions/state/service";

import { Options } from "../types/HandleSourceCreationOptions";

type Params = Omit<Options, "stripeElements"> & {
  subscriptionId: string;
};

export function handleAuthentication({
  subscriptionId,
  stripe,
  onStart,
  onError,
  onSuccess,
  onRetryPaymentRequired
}: Params) {
  return async function (dispatch: Dispatch, getState: GetState) {
    onStart && onStart();
    const paymentIntentClientSecret =
      await fetchPaymentIntentClientSecret(subscriptionId);

    dispatch(secureAuthenticationProcessingStarted());

    // Shows Stripe SCA modal and awaits user input
    const { error } = await stripe.confirmCardPayment(
      paymentIntentClientSecret
    );

    const response = await dispatch(
      confirmSubscriptionStatus(subscriptionId, subscriptionId)
    );

    if (error) {
      if (subscriptionPaymentFailed(getState(), subscriptionId)) {
        dispatch(setPaymentError(error.message));
        onRetryPaymentRequired(subscriptionId);
      } else {
        onError && onError(error.message);
      }
    } else {
      const state = getState();
      if (subscriptionIsActive(state, subscriptionId)) {
        onSuccess &&
          onSuccess({
            oldSubscription: response
          });
      } else {
        onError && onError("Sorry, something went wrong");
      }
    }

    dispatch(secureAuthenticationProcessingFinished());
  };
}
